@keyframes selected-item-animation {
    from {
        background: rgb(from var(--cs-origin) r g b / 20%);
    }

    to {
        background: rgb(from var(--cs-origin) r g b / 10%);
        color: var(--cs-dark);
    }
}

.list {
    background: white;
    border: 1px solid var(--border-color);

    &.borderless {
        border: none;
    }

    &.disabled {
        pointer-events: none;
        opacity: var(--disabled-opacity);
    }

    padding: 1rem 0 1rem 0;

    & > li {

        position: relative;
        overflow: hidden;
        padding: 0.5rem 1.5rem 0.5rem 1.5rem;
        display: block;
        cursor: pointer;
        border-left: 0.3rem solid transparent;

        /*&:nth-of-type(2n-1) {
            background: rgba(0, 0, 0, 0.01);
        }

        &:nth-of-type(2n) {
            background: rgba(0, 0, 0, 0.03);
        }*/

        &:hover {
            color: var(--cs-hover);
        }

        &.selected {
            background: rgb(from var(--cs-origin) r g b / 10%);
            padding: 0.5rem 1.5rem 0.5rem 1.5rem;
            border-left: 0.3rem solid var(--cs-origin) !important;
            /*animation-name: selected-item-animation;
            animation-duration: 0.2s;
            animation-fill-mode: forwards;*/
        }
    }
}